import React from 'react';
import PropTypes from 'prop-types';
import bindAll from 'lodash.bindall';
import RecordingStepComponent from '../components/record-modal/recording-step.jsx';
import AudioRecorder from '../lib/audio/audio-recorder.js';
import {defineMessages, injectIntl, intlShape} from 'react-intl';

import {isMobile} from '../lib/platform';

const messages = defineMessages({
    alertMsg: {
        defaultMessage: 'Could not start recording',
        description: 'Alert for recording error',
        id: 'gui.recordingStep.alertMsg'
    }
});

class RecordingStep extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleRecord',
            'handleRecordIpad',
            'handleStopRecording',
            'handleCancelRecordingIpad',
            'handleStopRecordingIpad',
            'handleStarted',
            'handleLevelUpdate',
            'handleRecordingError'
        ]);
       
        this.state = {
            listening: false,
            level: 0,
            levels: null
        };
        this.isIpad = isMobile();
        if (this.isIpad) {
            this.state.listening = true;
            this.handleRecord = this.handleRecordIpad;
            this.handleStopRecording = this.handleStopRecordingIpad;
            // 用于ipad上录音时发生错误调用
            window.handleRecordError = this.handleCancelRecordingIpad;
        }
    }
    componentDidMount () {
        if (!this.isIpad) {
            this.audioRecorder = new AudioRecorder();
            this.audioRecorder.startListening(this.handleStarted, this.handleLevelUpdate, this.handleRecordingError);
        }
    }
    componentWillUnmount () {
        if (this.isIpad) {
            if (this.timeout) clearTimeout(this.timeout);
            window.handleRecordError = null;
        } else {
            this.audioRecorder.dispose();
        }
        
        
    }
    handleStarted () {
        this.setState({listening: true});
    }
    handleRecordingError () {
        alert(this.props.intl.formatMessage(messages.extensionUrl)); // eslint-disable-line no-alert
    }
    handleLevelUpdate (level) {
        this.setState({level});
        if (this.props.recording) {
            this.setState({levels: (this.state.levels || []).concat([level])});
        }
    }
    handleRecord () {
        this.audioRecorder.startRecording();
        this.props.onRecord();
    }
    handleRecordIpad () {
        const baseArr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        const getRandomIndex = () => (Math.round(Math.random() * 10));
        const getFloatNum = () => {
            const part1 = `0.${Math.round(Math.random())}`;
            let part2 = '';
            let i = 0;
            while (i < 15) {
                part2 += baseArr[getRandomIndex()];
                i++;
            }
            return parseFloat(part1 + part2);
        };
        const levelUpdate = () => {
            this.handleLevelUpdate(getFloatNum());
            if (this.timeout) {
                clearTimeout(this.timeOut);
            }
            this.timeout = setTimeout(levelUpdate, 300);
        };
        levelUpdate();
        this.props.onRecord();
    }
    handleStopRecording () {
        const {samples, sampleRate, levels, trimStart, trimEnd} = this.audioRecorder.stop();
        this.props.onStopRecording(samples, sampleRate, levels, trimStart, trimEnd);
    }
    handleStopRecordingIpad () {
        this.props.onStopRecording();
        if (this.timeout) clearTimeout(this.timeout);

    }
    handleCancelRecordingIpad (){
        this.props.onCancelRecordingIpad();
        if (this.timeout) clearTimeout(this.timeout);
    }

    render () {
        const {
            onRecord, // eslint-disable-line no-unused-vars
            onStopRecording, // eslint-disable-line no-unused-vars
            ...componentProps
        } = this.props;
        return (
            <RecordingStepComponent
                level={this.state.level}
                levels={this.state.levels}
                listening={this.state.listening}
                onRecord={this.handleRecord}
                onStopRecording={this.handleStopRecording}
                {...componentProps}
            />
        );
    }
}

RecordingStep.propTypes = {
    intl: intlShape.isRequired,
    onCancelRecordingIpad: PropTypes.func,
    onRecord: PropTypes.func.isRequired,
    onStopRecording: PropTypes.func.isRequired,
    recording: PropTypes.bool
};

export default injectIntl(RecordingStep);
